import React from "react";
import { theme } from "../../../assets/theme";
import logoiconsmall from "../../../assets/img/logo-icon-small.svg";
import logotextsmall from "../../../assets/img/logo-text-small.svg";
import { Col, Divider, Flex, Row, Space } from "antd";
import {
  CopyrightOutlined,
  FacebookFilled,
  InstagramFilled,
  LinkedinFilled,
  TwitterOutlined,
  WhatsAppOutlined,
  YoutubeFilled,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const Footer = ({ isTabletOrMobile }) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        padding: 60,
        paddingTop: isTabletOrMobile ? 60 : 120,
        background: theme.colors.lightBlue,
      }}
    >
      <Row>
        <Col xl={8} lg={8} md={8} sm={22} xs={22} style={{ paddingLeft: 60 }}>
          <div className="footer-logo">
            {" "}
            {/* Add wrapper */}
            <img src={logoiconsmall} />
            <img src={logotextsmall} />
          </div>
          <Row>
            <p style={{ fontSize: 16, color: theme.colors.darkGray }}>
              Revolutionalise care with devices engineered
              <br /> to transform health and inspire trust.
            </p>
          </Row>
          <Row>
            <Flex gap={40}>
              <a
                href="https://www.instagram.com/cenvance_innovations_ltd._uk"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "black" }}
              >
                <InstagramFilled style={{ fontSize: 18 }} />
              </a>
              <a
                //  href="https://www.facebook.com/your-page"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "black" }}
              >
                <FacebookFilled style={{ fontSize: 18 }} />
              </a>
              {/* <a
                // href="https://twitter.com/your-profile"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "black" }}
              >
                <TwitterOutlined style={{ fontSize: 18 }} />
              </a> */}
              {/* <a
                //href="https://www.youtube.com/your-channel"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "black" }}
              >
                <YoutubeFilled style={{ fontSize: 18 }} />
              </a> */}
              <a
                href="https://www.linkedin.com/company/cenvance-innovation-ltd-uk/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "black" }}
              >
                <LinkedinFilled style={{ fontSize: 18 }} />
              </a>
              <a
                href="https://wa.me/+442033183727"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "black" }}
              >
                <WhatsAppOutlined style={{ fontSize: 18 }} />
              </a>
            </Flex>
          </Row>
        </Col>
        <Col xl={4} lg={4} md={4} sm={22} xs={22}>
          <div
            style={{
              color: theme.colors.darkGray,
              fontSize: 14,
              paddingLeft: isTabletOrMobile ? 20 : 40,
              paddingTop: isTabletOrMobile ? 16 : 5, // Increased left padding
              textAlign: "center",
            }}
          >
            <p
              style={{
                fontWeight: 600,
                margin: 0,
                color: theme.colors.black,
              }}
            >
              Address:
            </p>
            <p style={{ margin: 0, color: theme.colors.black }}>
              Cenvance Innovations Ltd.
            </p>
            <p style={{ margin: 0, color: theme.colors.black }}>
              85 Great Portland Street{" "}
            </p>
            <p style={{ margin: 0, color: theme.colors.black }}> First Floor</p>
            <p style={{ margin: 0, color: theme.colors.black }}>
              London,W1W 7LT
            </p>
            <p style={{ margin: 0, color: theme.colors.black }}>
              United Kingdom
            </p>
          </div>
        </Col>
        <Col xl={4} lg={4} md={4} sm={22} xs={22}>
          <div
            style={{
              color: theme.colors.darkGray,
              fontSize: 14,
              paddingLeft: isTabletOrMobile ? 20 : 40,
              paddingTop: isTabletOrMobile ? 16 : 5, // Increased left padding
              textAlign: "center",
            }}
          >
            <p
              style={{ fontWeight: 600, margin: 0, color: theme.colors.black }}
            >
              Contact Info:
            </p>
            <p style={{ margin: 0, color: theme.colors.black }}>
              Info@cenvance.com
            </p>
          </div>
        </Col>
        <Col xl={8} lg={8} md={8} sm={22} xs={22}>
          <Flex justify={"flex-end"}>
            <div style={{ paddingRight: isTabletOrMobile ? 20 : 60 }}>
              <p>
                <a style={{ color: theme.colors.black }} href="/about">
                  About Us
                </a>
              </p>
              <p>
                <a style={{ color: theme.colors.black }} href="/contact">
                  {" "}
                  Contact Us
                </a>
              </p>
              <p>Get Quote</p>
            </div>
            <div style={{ paddingRight: isTabletOrMobile ? 20 : 60 }}>
              <p
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/lab-equipment/laboratory-shakers")}
              >
                Lab Equipment
              </p>
              <p
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/medical-devices/laboratory-baths")}
              >
                Medical Devices
              </p>
              <p
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/lab-supplies/vacuum-pumps")}
              >
                Lab Supplies
              </p>
            </div>
          </Flex>
        </Col>
      </Row>
      <Row style={{ paddingTop: 20 }}>
        <Divider />
      </Row>
      <Row
        gutter={[0, 20]}
        justify={"space-between"}
        style={{ padding: isTabletOrMobile ? 0 : "0px 60px" }}
      >
        <label style={{ color: theme.colors.darkGray }}>
          <CopyrightOutlined />
          2025 Cenvance All rights reserved
        </label>
        <Space size={32}>
          <label style={{ color: theme.colors.darkGray }}>
            Terms of Service
          </label>
          <label>
            <a style={{ color: theme.colors.darkGray }} href="/privacy">
              Privacy Policy
            </a>
          </label>
          <label style={{ color: theme.colors.darkGray }}>Cookies</label>
        </Space>
      </Row>
    </div>
  );
};

export default Footer;
